export default __webpack_public_path__ + "fonts/fundo_outros_negocios.svg";